import React from 'react';
import { ACTIVITY_TYPES } from '../../platform/store/useOperationalStore';
import ActivityForm from './ActivityForm';
import ActivityItem from './ActivityItem';

const DEFAULT_TOOLBAR_TYPES = (canNote, canPhoto) => [
  { type: ACTIVITY_TYPES.NOTE,    label: '+ Note',    show: canNote },
  { type: ACTIVITY_TYPES.FINDING, label: '+ Finding', show: canNote },
  { type: ACTIVITY_TYPES.REPAIR,  label: '+ Repair',  show: canNote },
  { type: ACTIVITY_TYPES.PHOTO,   label: '+ Photo',   show: canPhoto },
];

// Renders a toolbar + inline add form + a filtered activity stream. Reused
// for both the full Activity tab and the Findings-only tab (different
// `activities` and `toolbarTypes`, same list/form machinery).
export default function ActivityStream({
  isClosed, canNote, canPhoto, activeForm, setActiveForm, submitting,
  onSubmitActivity, activities, onPhotoExpand,
  toolbarTypes, emptyMessage = 'No activity yet.',
}) {
  const buttons = (toolbarTypes || DEFAULT_TOOLBAR_TYPES(canNote, canPhoto)).filter(b => b.show);

  return (
    <>
      {!isClosed && buttons.length > 0 && (
        <div className="ro-act-toolbar">
          {buttons.map(b => (
            <button key={b.type}
              className={`ro-act-type-btn ${activeForm === b.type ? 'active' : ''}`}
              onClick={() => setActiveForm(f => f === b.type ? null : b.type)}>
              {b.label}
            </button>
          ))}
        </div>
      )}

      {activeForm && (
        <ActivityForm
          activeType={activeForm}
          onClose={() => setActiveForm(null)}
          onSubmit={onSubmitActivity}
          disabled={submitting}
        />
      )}

      <div className="ro-stream">
        {activities.length === 0 && (
          <div className="ro-stream-empty">{emptyMessage}</div>
        )}
        {activities.map(a => (
          <ActivityItem key={a.id} activity={a} onPhotoExpand={onPhotoExpand} />
        ))}
      </div>
    </>
  );
}
